<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">挖矿设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>分红设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <share-switch></share-switch>
      <share-check></share-check>
    </el-card>
  </div>
</template>

<script>
import './store';
import ShareSwitch from './components/Switch';
import ShareCheck from './components/Check';

export default {
  name: 'MiningShareSetting',
  components: {
    ShareSwitch,
    ShareCheck
  }
};
</script>

<style lang="less" scoped></style>
